import { ActionTree } from 'vuex';
import { Store } from '@/store/types';
import { AddressCorrectionState, CorrectAddressesCommand, GetInvalidAddressesQuery, GetInvalidAddressQuery } from '../types';
import { correctAddresses, getInvalidAddress, getInvalidAddresses } from '../service';

export const addressCorrectionActions: ActionTree<AddressCorrectionState, Store> = {

  // -- Trigger

  updateInvalidAddressesLimit({ commit, dispatch }, limit: number): Promise<void> {
    commit('setLimit', limit);
    return dispatch('getInvalidAddresses');
  },

  // -- Queries

  getInvalidAddresses({ commit, state }): Promise<void> {
    const query: GetInvalidAddressesQuery = {
      limit: state.limit,
    };
    commit('getInvalidAddressesStarted');
    return getInvalidAddresses(query)
      .then((invalidAddresses) => commit('getInvalidAddressesSucceeded', invalidAddresses))
      .catch((error) => {
        commit('getInvalidAddressesFailed');
        return Promise.reject(error);
      });
  },

  getInvalidAddress({ commit, state }, query: GetInvalidAddressQuery): Promise<void> {
    commit('getInvalidAddressStarted');
    return getInvalidAddress(query)
      .then((invalidAddress) => commit('getInvalidAddressSucceeded', invalidAddress))
      .catch((error) => {
        commit('getInvalidAddressFailed');
        return Promise.reject(error);
      });
  },

  // -- Commands

  correctAddresses({ commit, dispatch, state }, command: CorrectAddressesCommand): Promise<void> {
    commit('correctAddressesStarted');
    return correctAddresses(command)
      .then(() => dispatch('getInvalidAddresses'))
      .then(() => commit('correctAddressesSucceeded'))
      .catch((error) => {
        commit('correctAddressesFailed');
        return Promise.reject(error);
      });
  },

};
